import { render, staticRenderFns } from "./IpoPortfolio.vue?vue&type=template&id=11f49173&scoped=true"
import script from "./IpoPortfolio.vue?vue&type=script&lang=js"
export * from "./IpoPortfolio.vue?vue&type=script&lang=js"
import style0 from "./IpoPortfolio.vue?vue&type=style&index=0&id=11f49173&prod&lang=scss"
import style1 from "./IpoPortfolio.vue?vue&type=style&index=1&id=11f49173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f49173",
  null
  
)

export default component.exports